$ = require 'jquery'
Backbone = require 'backbone'
Singleton = require '../../pattern/singleton'
Data = require '../data'
Router = require '../router'
OnePageScroll = require './one-page-scroll'
Menu = require './menu'
{ getParam, deleteParam } = require './params'
{ parse } = require '../../components/query-string'

module.exports =
class Link extends Singleton

  menuParams: 'menu'

  constructor: ->
    super

    $ 'a'
      .on 'click', @onClicked

    @host         = location.host
    @hasPushState = window.history and history.pushState

    @onePageScroll = OnePageScroll.getInstance()
    @menu          = Menu.getInstance()

  onClicked: (e) =>
    el  = e.currentTarget
    url = el.href

    return if !url.match(RegExp('^(http|https):\/\/' + @host + '.*$'))
    e.preventDefault()
    return if @onePageScroll.isAnime

    $el  = $(el)
    href = $el.attr 'href'

    target = href.match(/^\/(.+)\/.*$/)?[1] || ''
    count  = 0
    for key, val of Router::routes
      if val.match(target) then break else count++
    params   = Data.params[count]
    fragment = ''

    setFragment = ->
      query = $.param params
      fragment =
        if query then "#{href}?#{query}" else href

    setFragment()

    nowFragment =
      if @hasPushState
        "#{location.pathname.replace('index.html', '')}#{location.search}"
      else
        location.hash.replace '#', ''
    if fragment is nowFragment
       getParam(@menuParams) is 'open'
      delete params[@menuParams]
      setFragment()

    Backbone.history.navigate fragment, true



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/link.coffee